import React from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
import Dashboard from './layout/dashboard.js'
import Login from './pages/login/login.js'
import SubAdmin from './pages/admin/subAdmin.js'

import { isEmpty } from 'lodash'
import { ACCESS_LEVEL } from './constant/constant.js'
import { useSelector } from 'react-redux'

import Loader from './components/loader.js'
import ProtectedRoute from './layout/protectedRoute.js'

import AdminDashboard from './pages/dashboard/index.js'
// import ChipsMaster from './pages/chipsMaster/index.js'
import Withdrawal from './pages/withdrawalModule/index.js'
import Deposit from './pages/depositModule/index.js'
import Shift from './pages/shiftManagement/index.js'
import OpeningBalance from './pages/openingBalance/index.js'
import LedgerPage from './pages/ledger/index.js'
import PaymentOffers from './pages/paymentOffer/index.js'
import Transaction from './pages/transaction/index.js'
import MemberManagerPage from './pages/memberManager/index.js'
import EditPaymentOffer from './pages/paymentOffer/edit.js'
import AddPaymentOffer from './pages/paymentOffer/add.js'
import ViewUserInfo from './pages/paymentOffer/view.js'
import Loan from './pages/loan/index.js'
import ChipsMaster from './pages/chipsMaster/index.js'
import Rake from './pages/rake/index.js'
import TipManager from './pages/tip/index.js'
import ChipIssue from './pages/chipIssue/index.js'
import ChipCashOut from './pages/chipCashOut/index.js'
import ChipExchange from './pages/chipExchange/index.js'
import FloatExchange from './pages/floatExchange/index.js'
import AppSettings from './pages/settings/index.js'
import UserManager from './pages/userManager/index.js'
import ExpenseManager from './pages/expense/index.js'
import DailyExpenseManager from './pages/dailyExpense/index.js'
import WalletManager from './pages/walletManager/index.js'
import SessionManager from './pages/sessionManager/index.js'
import TelegramCashierPage from './pages/telegramCashier/index.js'
import EmployeeManagerPage from './pages/employeeManager/index.js'
import BadBeatJackpot from './pages/badBeatJackpot/index.js'
import BBJDisplay from './pages/badBeatJackpot/display.js'
import AccountManager from './pages/accountManager/index.js'
import PlayerManager from './pages/playerManager/index.js'
import DealerTipPage from './pages/dealerTip/index.js'
// import EMIManager from './pages/emi/index.js'

function Router() {
    const accessCokies = useSelector(state => state.loginSlice);
    let loader = accessCokies.loading ? <Loader /> : null;

    const cmsRoutes = [
        {
            element: <Dashboard />,
            children: [
                {
                    element:  <ProtectedRoute access_level={ACCESS_LEVEL.SUB_ADMIN}/>,
                    children: [

                        {
                            path: '/',
                            element: <Navigate to="/shift-management" replace />
                        },
                        {
                            path: '/opening-balance',
                            element : <OpeningBalance />
                        },
                        {
                            path: '/shift-management',
                            element : <Shift />
                        },
                        {
                            path: '/deposit',
                            element : <Deposit />
                        },
                        {
                            path: '/withdrawal',
                            element : <Withdrawal />
                        },
                        
                        {
                            path: '/transaction',
                            element : <Transaction />
                        },
                        {
                            path: '/member-manager',
                            element : <MemberManagerPage />
                        },
                        {
                            path: '/chips-master',
                            element : <ChipsMaster />
                        },
                        {
                            path: '/loan',
                            element : <Loan />
                        },
                        {
                            path: '/rake',
                            element : <Rake />
                        },
                        {
                            path: '/tip-manager',
                            element : <TipManager />
                        },
                        {
                            path: '/chip-issue',
                            element : <ChipIssue />
                        },
                        {
                            path: '/chip-cashout',
                            element : <ChipCashOut />
                        },
                        {
                            path: '/chip-exchange',
                            element : <ChipExchange />
                        },
                        {
                            path: '/float-exchange',
                            element : <FloatExchange />
                        },
                        {
                            path: '/expense',
                            element : <ExpenseManager />
                        },
                        {
                            path: '/daily-expense',
                            element : <DailyExpenseManager />
                        },


                    ]
                },
                {
                    element:  <ProtectedRoute access_level={ACCESS_LEVEL.ADMIN}/>,
                    children:[
                        {
                            path:'/sub-admin',
                            element : <SubAdmin/>
                        },
                        {
                            path: '/wallet-manager',
                            element : <WalletManager />
                        },
                        
                        {
                            path:'/dashboard',
                            element : <AdminDashboard/>
                        }, 
                        {
                            path: '/shift-ledger',
                            element : <LedgerPage />
                        },
                        {
                            path: '/session-manager',
                            element : <SessionManager />
                        },
                        {
                            path: '/payment-offer',
                            element : <PaymentOffers />
                        }, 
                        {
                            path: '/payment-offer/add',
                            element : <AddPaymentOffer />
                        },
                        {
                            path: '/payment-offer/view/:id',
                            element : <ViewUserInfo />
                        },
                        {
                            path: '/payment-offer/edit/:id',
                            element : <EditPaymentOffer />
                        },
                        {
                            path: '/settings',
                            element : <AppSettings />
                        },
                        {
                            path: '/user-manager',
                            element : <UserManager />
                        },
                        {
                            path: '/telegram-cashier',
                            element : <TelegramCashierPage />
                        },
                        {
                            path: '/employee-manager',
                            element : <EmployeeManagerPage />
                        },
                        {
                            path: '/bad-beat-jackpot',
                            element : <BadBeatJackpot />
                        },
                        {
                            path: '/account-manager',
                            element : <AccountManager />
                        },
                        {
                            path: '/player-manager',
                            element : <PlayerManager />
                        },


                    ]
                },
              
            ]
        },
       
        {
            path: "/login",
            element: !isEmpty(accessCokies.token) ? <Navigate to="/shift-management" replace={true} /> : <Login />,
        },
        {
            path: "/bbj-display",
            element: <BBJDisplay />,
        },
        {
            path: "/dealer-tip",
            element: <DealerTipPage />,
        },

    ]

    const Route = useRoutes(cmsRoutes)
    return accessCokies.loading ? <Loader /> : Route;
}

export default Router
